/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { alertMsg } from "../utilities/helper";
import { url } from "./api";
import { delOne, getAll, getOne } from "./helper";
import { jwt } from "./api";

const initialState = {
  render: false,
  serviceID: null,
  categoryID: null,
  edit: false,
  delete: false,
  loading: false,
  service: {},
  allServices: [],
  success: null,
  error: "",
};

export const EditServiceAtrr = createAsyncThunk(
  "service Attributes",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const urlAdd = `${url}/service-attributes/${obj.id}`;
    try {
      const response = await axios({
        method: "get",
        url: urlAdd,
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      alertMsg(" تمت العملية بنجاح", true);
      return response;
    } catch (err) {
      alertMsg("فشلت العملية", false);
      return rejectWithValue(err);
    }
  }
);

export const postService = createAsyncThunk(
  "postCategory",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const urlAdd = `${url}/services`;
    const urlUpdate = `${url}/services/${obj.serviceID}`;

    try {
      const response = await axios({
        method: "POST",
        url: obj.method === "PUT" ? urlUpdate : urlAdd,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
        data: {
          category_id: obj.categoryID,
          name_en: obj.en_name,
          name_ar: obj.ar_name,
          description_en: obj.cond_en,
          description_ar: obj.desc_ar,
          terms_conditions_en: obj.cond_en,
          terms_conditions_ar: obj.cond_ar,
          status: obj.cat_status ? obj.cat_status.value : "active",
          image: obj.photo,
          price: obj.price,
        },
      });
      alertMsg(" تمت العملية بنجاح", true);
      return response;
    } catch (err) {
      alertMsg("فشل اضافة البيانات حاول مرة اخري", false);

      return rejectWithValue(err);
    }
  }
);
export const updateServiceAttr = createAsyncThunk(
  "post",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const urlAdd = `${url}/service-attributes/${obj.serviceID}`;

    try {
      console.log(obj);
      const response = await axios({
        method: "POST",
        url: urlAdd,
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: obj.data,
      });
      alertMsg(" تمت العملية بنجاح", true);
      return response;
    } catch (err) {
      alertMsg("فشل اضافة البيانات حاول مرة اخري", false);

      return rejectWithValue(err);
    }
  }
);
const service = createSlice({
  name: "services",
  initialState,
  reducers: {
    setServiceCatIDS(state, action) {
      state.serviceID = action.payload.serviceID;
      state.categoryID = action.payload.categoryID;
    },
    deleteServiceRTK(state) {
      state.allServices = state.allServices.filter(
        (item) => item.id !== service.serviceID
      );
    },
    setEdit(state, action) {
      state.edit = action.payload.edit;
    },
    setDelete(state, action) {
      state.delete = action.payload.delete;
    },
  },
  extraReducers: (builder) => {
    //delete services
    builder.addCase(delOne.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(delOne.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(delOne.rejected, (state, action) => {
      state.loading = false;
    });
    //create service
    builder.addCase(postService.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(postService.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(postService.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload.response.data.message;
    });
    // get one service
    builder.addCase(getOne.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = "";
      state.service = action.payload.data;
    });
    builder.addCase(getOne.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload.response.data.message;
    });
  },
});

export default service.reducer;
export const { setServiceCatIDS, setEdit, setDelete, deleteServiceRTK } =
  service.actions;
